import React from 'react';
import { formatExhibitionBannerDates } from './exhibitionsDisplay';
import { HOME_COPY_DEFAULTS } from './content/pageCopyDefaults';

/**
 * Top-of-home strip: next upcoming show (API returns upcoming sorted by start date ascending).
 */
export default function HomeNextExhibitionBanner({ upcoming, homeCopy = {} }) {
  const next = upcoming?.[0];
  if (!next) return null;

  const badgeLabel = homeCopy.next_exhibition_badge || HOME_COPY_DEFAULTS.next_exhibition_badge;
  const ctaLabel = homeCopy.next_exhibition_cta_label || HOME_COPY_DEFAULTS.next_exhibition_cta_label;

  const title = next.title?.trim();
  const where = [next.venue, [next.city, next.country].filter(Boolean).join(', ')].filter(Boolean).join(' · ');
  const when = formatExhibitionBannerDates(next.event_start, next.event_end);

  return (
    <aside className="home-next-exhibition" aria-label="Next exhibition">
      <div className="home-next-exhibition__inner">
        <span className="home-next-exhibition__badge">{badgeLabel}</span>
        <div className="home-next-exhibition__text">
          <p className="home-next-exhibition__line">
            <time className="home-next-exhibition__date" dateTime={next.event_start}>
              {when}
            </time>
            {where ? (
              <>
                <span className="home-next-exhibition__sep" aria-hidden="true">
                  ·
                </span>
                <span className="home-next-exhibition__where">{where}</span>
              </>
            ) : null}
          </p>
          {title ? <p className="home-next-exhibition__title">{title}</p> : null}
        </div>
        <a href="#exhibitions-shows" className="home-next-exhibition__cta btn btn-sm">
          {ctaLabel}
        </a>
      </div>
    </aside>
  );
}
